export default __webpack_public_path__ + "static/media/108_desktop.64b9333a.jpg";